import { getContext, setContext } from 'svelte';

/**
 * 'tree' ist der senkrechte Baum mit Auf-/Zu-Buttons (Sidebar und mobiles Menü),
 * 'bar' die waagerechte Leiste der Ebene 1 mit Flyouts.
 */
export type NavigationVariant = 'tree' | 'bar';

export interface VariantContext {
    variant: NavigationVariant;
}

export class NavigationService {
    private static readonly ContextKey = 'navigation-variant';
    private static readonly DefaultVariant: NavigationVariant = 'tree';

    public getVariant(): NavigationVariant {
        const SearchContext = getContext<(() => VariantContext | undefined) | undefined>(NavigationService.ContextKey);

        if (!SearchContext) {
            return NavigationService.DefaultVariant;
        }

        return SearchContext()?.variant ?? NavigationService.DefaultVariant;
    }

    public setVariant(variant: NavigationVariant): void {
        const WriteContext: VariantContext = { variant };
        setContext(NavigationService.ContextKey, () => WriteContext);
    }

    /**
     * Gegenstück zu LayerService.upNavigationLayer(): Ebene 1 gibt die Variante vor,
     * verschachtelte Navigationen erben sie, ohne sie zu überschreiben.
     */
    public resolveVariant(variant: NavigationVariant | undefined): NavigationVariant {
        const NextVariant = variant ?? this.getVariant();
        this.setVariant(NextVariant);

        return NextVariant;
    }
}
